<template>
  <div class="content-section" v-loading="loading" element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <h2 class="page-title">佣金管理</h2>
    <div style="background-color: #f0f8ff; padding: 20px; border-radius: 8px; margin-bottom: 20px; border-left: 4px solid #1a3a6c;">
      <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
        <h3 style="color: #1a3a6c; ">佣金汇总</h3>
        <el-button @click="toCash" type="success">去提现</el-button>
      </div>

      <div style="display: flex; justify-content: space-around; text-align: center;">
        <div>
          <p style="font-size: 14px; color: #666;margin-bottom: 10px;">佣金总额</p>
          <p style="font-size: 32px; color: #28a745; font-weight: bold;">¥{{money.CommissionTotalAmount}}</p>
        </div>
        <div>
          <p style="font-size: 14px; color: #666;margin-bottom: 10px;">累计提现</p>
          <p style="font-size: 32px; color: #1a3a6c; font-weight: bold;">¥{{money.CumulativeDrawMoney || 0}}</p>
        </div>
        <div>
          <p style="font-size: 14px; color: #666;margin-bottom: 10px;">提现冻结</p>
          <p style="font-size: 32px; color: #28a745; font-weight: bold;">¥{{money.FreezingAmount || 0}}</p>
        </div>
        <div>
          <p style="font-size: 14px; color: #666;margin-bottom: 10px;">佣金余额</p>
          <p style="font-size: 32px; color: #ffc107; font-weight: bold;">¥{{money.CanUseBalance || 0}}</p>
        </div>
      </div>
    </div>
    <h3 style="color: #1a3a6c; margin-bottom: 15px;">佣金明细</h3>
    <div class="form-row" style="margin-bottom: 10px;">
      <div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          @change="changeTime"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <el-select v-model="queryParams.ApplyState" clearable placeholder="状态">
        <el-option
          v-for="(item,index) in options1"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="queryParams.EntryType" clearable placeholder="类型">
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="searchBy" type="primary">查询</el-button>
      <!--<div class="form-group" style="align-self: flex-end;">-->
        <!--<button class="btn btn-primary" style="width: 80px;" @click="searchBy">查询</button>-->
      <!--</div>-->
    </div>
    <div>
      <el-table
        :data="CommissionData"
        height="500"
        border
        style="width: 100%">
        <el-table-column
          prop="F_ContractId"
          label="编号"
          align="center"
          header-align="center"
          width="160"
          >
        </el-table-column>
        <el-table-column
          prop="F_ContractName"
          label="名称"
          align="center"
          header-align="center"
          >
        </el-table-column>
        <el-table-column
          prop="F_ApplyState"
          label="提现状态"
          align="center"
          header-align="center"
          width="120"
          >
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.F_ApplyState == 0" size="medium">未提现</el-tag>
            <el-tag type="primary" v-else-if="scope.row.F_ApplyState == 1" size="medium">提现中</el-tag>
            <el-tag v-else-if="scope.row.F_ApplyState == 2" size="medium" type="success">已提现</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="F_EntryType"
          label="类型"
          align="center"
          header-align="center"
          width="120"
          >
          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.F_EntryType == 1" size="medium">入驻费分成</el-tag>
            <el-tag v-else-if="scope.row.F_EntryType == 2" size="medium" type="success">业务分成</el-tag>
            <el-tag v-else-if="scope.row.F_EntryType == 3" size="medium" type="danger">入驻管理津贴</el-tag>
            <el-tag v-else-if="scope.row.F_EntryType == 4" size="medium" type="info">业务管理津贴</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="F_EntryTime"
          align="center"
          header-align="center"
          width="160"
          label="结算时间">
        </el-table-column>
        <el-table-column
          prop="F_Amount"
          align="center"
          header-align="center"
          width="120"
          label="金额">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total>0"
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        queryParams: {
          EntryType:'',
          ApplyState:'',
          StartTime:this.getFirstDayOfMonth(),
          EndTime:new Date().format('yyyy-MM-dd') +' 23:59:59'
        },
        url: {
          list: SZH.assets.api + '/Custom/GetPagingCommissionInfos',
          GetMyCommissionEntity: SZH.assets.api + '/Custom/GetMyCommissionEntity',
        },
        loading: false,
        value1:[this.getFirstDayOfMonth(),new Date().format('yyyy-MM-dd') +' 23:59:59'],
        moneyAll:0,
        CommissionData:[],
        PageIndex:1,
        PageSize:50,
        total:0,
        options:[
          {label:'入驻费分成',value:'1'},
          {label:'业务分成',value:'2'},
          {label:'入驻管理津贴',value:'3'},
          {label:'业务管理津贴',value:'4'},
        ],
        options1:[
          {label:'未提现',value:'0'},
          {label:'提现中',value:'1'},
          {label:'已提现',value:'2'},
        ],
        money:{
          CommissionTotalAmount:'',
          CumulativeDrawMoney:'',
          FreezingAmount :'',
          CanUseBalance :'',
        }
      }
    },
    methods: {
      toCash(){
        this.$router.push({
          path: '/My/CashRequest'
        });
      },
      searchBy(){
        let self = this;
        self.loadData();
      },
      getMoney(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.GetMyCommissionEntity,self.queryParams)
          .then(result => {
            if (result.state == true) {
              self.money.CommissionTotalAmount = result.data.CommissionTotalAmount;
              self.money.CumulativeDrawMoney = result.data.CumulativeDrawMoney;
              self.money.FreezingAmount = result.data.FreezingAmount;
              self.money.CanUseBalance = result.data.CanUseBalance;
              self.loading = false;
            } else {
              self.money.CommissionTotalAmount = 0;
              self.money.CumulativeDrawMoney = 0;
              self.money.FreezingAmount = 0;
              self.money.CanUseBalance = 0;
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
      changeTime(val){
        if(val && val.length>0){
          this.queryParams.StartTime = val[0];
          this.queryParams.EndTime = val[1];
        }
      },
      getFirstDayOfMonth() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}-01 00:00:00`;
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadData();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadData();
      },
      loadData(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.list,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.CommissionData = result.data.Data;
              self.total = result.data.TotalCount;
            } else {
              self.CommissionData = [];
              self.total = 0;
              self.$message.error(result.message);
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},
    components: {
    },
    mounted() {
      this.getMoney();
      this.loadData();
    }
  }
</script>

<style scoped>
.form-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.form-row .form-group {
  flex: 1;
}
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #000000;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #1a3a6c;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/CommissionManagement/CommissionManagement.vue